module.exports = __webpack_public_path__ + "static/media/xls.3ebb1abd.svg";